import { graphql } from 'relay-runtime';

export const RECOGNITION_SCHEDULE_QUERY = graphql`
  query RecognitionScheduleQuery($aaid: String!) {
    unified {
      unifiedProfile(aaid: $aaid) {
        ... on UnifiedQueryError {
          identifier
          message
          extensions {
            ... on UnifiedQueryErrorExtension {
              statusCode
              errorType
            }
          }
        }
        ... on UnifiedProfile {
          gamification {
            ... on UnifiedGamification {
              recognitionSchedule {
                ... on UnifiedGamificationRecognitionSchedule {
                  id
                  currentTime
                  availablePoints
                  isStaff
                  nextRefresh
                  refreshPtsAmount
                  resetPointsStatus
                  status
                  timeUntilRefresh
                  userId
                  wasForced
                  wasUpdateNeeded
                }
              }
            }
          }
        }
      }
    }
  }
`;
